/**
 * Card EM BREVE genérico (v1.5.468) — promovido de features/fidelize quando o
 * Módulo Fiscal passou a precisar do mesmo. Sem botão de ação de propósito:
 * botão que não faz nada ensina o lojista a desconfiar da tela (decisão da
 * aba Banners, v1.5.443).
 */
export default function EmBreveCard({ icon: Icon, titulo, descricao, itens = [] }) {
  return (
    <div className="flex flex-col items-center justify-center min-h-[380px] rounded-2xl border-2 border-dashed border-primary/25 bg-primary/[0.03] p-8 text-center">
      <div className="w-16 h-16 rounded-2xl bg-primary/10 flex items-center justify-center mb-4">
        <Icon className="w-8 h-8 text-primary" />
      </div>
      <span className="inline-flex items-center px-3 py-1 rounded-full bg-primary text-primary-foreground text-[10px] font-black uppercase tracking-wider mb-3">
        Em breve
      </span>
      <h3 className="font-bold text-xl mb-2">{titulo}</h3>
      <p className="text-sm text-muted-foreground max-w-md">{descricao}</p>
      {itens.length > 0 && (
        <ul className="mt-4 text-sm text-muted-foreground space-y-1.5 text-left">
          {itens.map((t) => (
            <li key={t} className="flex items-start gap-2">
              <span className="text-primary mt-0.5">•</span> {t}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
